import { AuthService } from '../services'

import { AuthAccessControlPolicy } from '#Auth/acl/Auth.ACL'
import { AuthRoutingService } from '#Auth/routing'
import { useAuthStore } from '#Auth/store'
import { AuthSupport } from '#Auth/support/AuthSupport'

export const useAuth = () => {
  const alt = useAlt()

  const services = {
    get service() {
      return alt.get(AuthService)
    },
    get acl() {
      return alt.get(AuthAccessControlPolicy)
    },
    get routing() {
      return alt.get(AuthRoutingService)
    },
    get support() {
      return alt.get(AuthSupport)
    },
  }

  function logout() {
    services.service.signOut()
  }

  return {
    ...services,
    get store() {
      return useAuthStore()
    },
    logout,
  }
}
